import { render, staticRenderFns } from "./btnConfirmlost.vue?vue&type=template&id=142ea4ca&scoped=true&"
import script from "./btnConfirmlost.vue?vue&type=script&lang=js&"
export * from "./btnConfirmlost.vue?vue&type=script&lang=js&"
import style0 from "./btnConfirmlost.vue?vue&type=style&index=0&id=142ea4ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142ea4ca",
  null
  
)

export default component.exports